class W4D_TOC {
    constructor() {
        if (!document.body.classList.contains('archive')) {
            return;
        }

        this.initSelectors();
        this.bindEvents();
        this.initializeState();
    }

    initSelectors() {
        this.submenuToggle      = '.aside-nav__submenu-toggle';
        this.submenuToggleOpen  = 'aside-nav__submenu-toggle--open';
        this.navList            = '.aside-nav__list';
        this.navListOpen        = 'aside-nav__list--open';
        this.navLink            = '.aside-nav__link';
        this.navLinkActive      = 'aside-nav__link--active';

        // Cache native elements for event binding
        this.asideChevrons = document.querySelectorAll(this.submenuToggle);
    }

    bindEvents() {
        const boundToggle = this.toggleSubmenu.bind(this);

        for (const chevron of this.asideChevrons) {
            chevron.addEventListener('click', boundToggle);
        }
    }

    initializeState() {
        const bodyClasses = document.body.className;
        const termMatch = bodyClasses.match(/\bterm-(\S+?)(?=\s|$)/);

        if (!termMatch) return;

        const slug = termMatch[1];
        let currentLink = null;

        const navLinks = document.querySelectorAll(this.navLink);

        for (const link of navLinks) {
            const href = link.getAttribute('href');
            if (!href) continue;

            const segments = href.split('/').filter(segment => segment.length > 0);
            const lastSegment = segments[segments.length - 1];

            if (lastSegment === slug) {
                currentLink = link;
                break; // Found it, stop searching
            }
        }

        if (!currentLink) return;

        currentLink.classList.add(this.navLinkActive);

        const parentLists = [];
        let current = currentLink;

        while (current) {
            current = current.closest(this.navList);
            if (current) {
                parentLists.push(current);
                current = current.parentElement;
            }
        }

        parentLists.forEach(list => {
            list.style.contentVisibility = 'visible';
            list.classList.add(this.navListOpen);

            // Find and activate parent toggle
            const parentToggle = list.previousElementSibling?.querySelector('.aside-nav__submenu-toggle');
            if (parentToggle) {
                parentToggle.classList.add('aside-nav__submenu-toggle--open');
            }
        });

        const nextSubmenu = currentLink.nextElementSibling;
        if (nextSubmenu?.matches(this.navList)) {
            nextSubmenu.style.contentVisibility = 'visible';
            nextSubmenu.classList.add(this.navListOpen);

            const toggleInLink = currentLink.querySelector(this.submenuToggle);
            if (toggleInLink) {
                toggleInLink.classList.add(this.submenuToggleOpen);
            }
        }
    }

    toggleSubmenu(e) {
        e.preventDefault();

        const toggle = e.target;
        const submenu = toggle.parentElement.nextElementSibling;

        if (!submenu) return;

        const isCurrentlyOpen = submenu.classList.contains(this.navListOpen);
        const transitionDuration = 300;

        if (isCurrentlyOpen) {
            // CLOSING: Close nested submenus first
            const nestedSubmenus = submenu.querySelectorAll(`.${this.navListOpen}`);
            for (const nestedSubmenu of nestedSubmenus) {
                nestedSubmenu.setAttribute('data-closing', 'true');
                nestedSubmenu.classList.remove(this.navListOpen);
                setTimeout(() => {
                    nestedSubmenu.removeAttribute('data-closing');
                }, transitionDuration);
            }

            // Close nested toggles
            const nestedToggles = submenu.querySelectorAll(`.${this.submenuToggleOpen}`);
            for (const nestedToggle of nestedToggles) {
                nestedToggle.classList.remove(this.submenuToggleOpen);
            }

            // Close main submenu
            submenu.setAttribute('data-closing', 'true');
            submenu.classList.remove(this.navListOpen);
            setTimeout(() => {
                submenu.removeAttribute('data-closing');
            }, transitionDuration);
        } else {
            submenu.classList.add(this.navListOpen);
        }

        toggle.classList.toggle(this.submenuToggleOpen);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new W4D_TOC());
} else {
    new W4D_TOC();
}